// ============================================================================= //
//  JS detection
// ============================================================================= //
document.body.classList.remove("no-js");




// ============================================================================= //
//  Modules
// ============================================================================= //

import "./modules/animation";
import "./modules/mobile-navigation";
import "./modules/site-header";
import "./modules/smooth-scroll";
import "./modules/animation";
import "./modules/accordion";
import "./modules/video";
import "./modules/swiper";
import "./modules/horizontal";
// import "./modules/panel";
import "./modules/panels";
import "./modules/tabs";







